<template>
  <section>
    <nav class="[ text-sm border-b pb-4 mb-4 ]">
      <ul class="[ flex items-center gap-4 ]">
        <li>
          <router-link to="/admin">
            <a class="[ underline text-primary ]">Admin home</a>
          </router-link>
        </li>
        <li class="[ border-l pl-4 ]">
          <router-link to="/admin/sentence-query-engine">
            <a class="[ underline text-primary ]">Sentence query engine</a>
          </router-link>
        </li>
        <li class="[ border-l pl-4 ]">
          <router-link to="/admin/sentences">
            <a class="[ underline text-primary ]">Sentences</a>
          </router-link>
        </li>
      </ul>
    </nav>

    <router-view />
  </section>
</template>
<script setup lang="ts">
definePage({
  redirect: "/admin/sentence-query-engine",
  meta: {
    title: "Admin",
    icon: "user-account",
  },
});
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/store/auth.ts";
import { useRouter } from "vue-router";

const router = useRouter();
const { isAdminUser } = storeToRefs(useAuthStore());

onMounted(() => {
  if (!isAdminUser.value) {
    router.push("/");
  }
});
</script>
